

import React, { useContext, useEffect, useState } from 'react';

function SideMenu({ menuList = [], screenId, setActiveScreenId }) {

    return (
        <div className='bg-white py-2 rounded'>
            <div className="h-10 flex flex-col text-sm text-gray-500 flex-1 ">
                {menuList.map((screen) => {
                    return <div key={screen.id}
                        onClick={() => setActiveScreenId(screen.id)}
                        className={`text-sm border-0  hover:bg-blue-200  cursor-pointer text-md whitespace-nowrap flex  items-center ${screenId === screen.id ? 'border-r-2  bg-blue-100 border-blue-500' : 'border-blue-200'}`}>
                        <span className="px-4 py-2">{screen.text}</span>
                    </div>
                })}
            </div>
        </div>
    );
}

export default SideMenu;

